import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import MyProfile from "../../layouts/MyProfile/MyProfile";


const MyProfilePage = () => {
    return(
        <>
            <ScrollToTopOnMount />
            <MyProfile />
        </>
        
    )
}

export default MyProfilePage;